<template>
    <div class="feature-section-container">
        <div class="section-header">
            <h3>おすすめポイント</h3>
        </div>
        <div class="section-content">
            <div class="feature-item">
                <div class="feature-title-wrapper">
                    <span class="icon">1</span>
                    <h4 class="feature-title">写真を送るだけで、<span class="bold-red">サクッと見積り可能！</span></h4>
                </div>
            </div>
            <div class="feature-item point2">
                <div class="feature-title-wrapper">
                    <span class="icon">2</span>
                    <h4 class="feature-title">見積り後の<span class="bold-red">追加費用は一切なし！</span></h4>
                </div>
            </div>
            <div class="feature-item point3 no-border">
                <div class="feature-title-wrapper">
                    <span class="icon">3</span>
                    <h4 class="feature-title">関西在住の方は<span class="bold-red">すぐに駆けつけ</span></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

.section-header {
    background-color: #3f51b5;
    color: white;
    padding: 1ch;
    margin-bottom: 20px;
    position: relative;
    text-align: center;
}

.section-header::before,
.section-header::after {
    /* リボンの“端” */
    content: "";
    position: absolute;
    top: 50%;
    width: 22px;
    height: 22px;
    background: #2f3f9c;
    /* 少し濃い青 */
    transform: translateY(-50%) rotate(45deg);
    opacity: 0.95;
}

.section-header::before {
    left: 12px;
}

.section-header::after {
    right: 12px;
}

.section-header h3 {
    margin: 0;
    font-size: 1.2rem;

    /* ▼ 追加：中央のタイトル装飾 */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 8px 18px;
    border-radius: 999px;
    letter-spacing: .03em;
    font-weight: 900;
    position: relative;
}

/* ===== 枠 ===== */
.feature-section-container {
    background-color: white;
    border: 1px solid gray;
    margin: 20px;
    margin-top: 0;
    margin-bottom: 0;
}

/* ===== 1行ごとの見やすさUP（カードっぽいが派手にしない） ===== */
.section-content {
    padding: 15px;
    padding-top: 0;
}

.feature-item {
    margin-bottom: 12px;
    border-bottom: 3px dotted gray;
    padding-bottom: 12px;
}

.feature-item.no-border {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.feature-title-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 0;
}

/* 数字アイコン：そのまま活かしつつ、サイズ感だけ整える */
.icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background-color: #ffc107;
    color: white;
    font-weight: 900;
    border-radius: 50%;
    margin-right: 0;
}

/* タイトル：読みやすく・行間調整 */
.feature-title {
    font-size: 0.9rem;
    color: #333;
    margin: 0;
    text-align: left;
    line-height: 1.45;
}

/* 下線や強調は既存クラスに任せる前提（bold-redがある想定） */
.feature-description {
    font-size: 14px;
    color: #555;
    line-height: 1.5;
    text-align: left;
}

/* 既存で残ってる汎用（今回未使用でも触らない） */
.image-box {
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 20px;
}

.image-box.yellow-border {
    border: 2px solid #ffc107;
}

.feature-image {
    width: 100%;
    height: auto;
    display: block;
}

.feature-item img {
    width: 100%;
    margin-bottom: 20px;
}

.point3 img {
    width: 80%;
    margin-top: 10px;
}

.point2 img,
.point4 img {
    width: 90%;
    margin-top: 10px;
    border-radius: 20px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .section-header {
        padding: 14px 10px;
        margin-bottom: 14px;
    }

    .section-header h3 {
        font-size: 1.1rem;
        padding: 8px 14px;
    }

    .section-content {
        padding: 10px;
        padding-top: 0;
    }

    .icon {
        width: 26px;
        height: 26px;
        font-size: .95rem;
    }

    .feature-title {
        font-size: 0.9rem;
    }

    .feature-description {
        font-size: 1rem;
    }

    .mitumori-label {
        font-size: 0.9rem;
        padding: 10px 15px;
    }

    .total-cost, .total-cost2 {
        font-size: 1rem;
    }

    .scroll-text {
        font-size: 0.7rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    .feature-section-container {
        margin: 5px;
    }

    .icon {
        width: 28px;
        height: 28px;
        font-size: 1.05rem;
    }

    .feature-title {
        font-size: 0.95rem;
    }

    .feature-description {
        font-size: 0.9rem;
    }
}
</style>
